<template>
  <ErrorBoundary>
    <NetworkConfigWrapper>
      <TerminalWebAppAccessGate>
        <AuthStateWatchers>
          <RouterView />
          <SupervisorLogInDrawer />

          <!-- Screensaver -->
          <HeadlessTransitionRoot
            class="absolute inset-0 z-20"
            :show="isScreensaverVisible"
            enter="transition-opacity duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="transition-opacity duration-150"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <img
              :src="splashImgSrc"
              class="size-full object-cover"
            />
          </HeadlessTransitionRoot>
          <AppUpdateNotification
            :is-open="
              showAppUpdatedNotification &&
              !showWebViewVersionWarning
            "
            :previous-version="previousVersion"
            @acknowledge="acknowledgeUpdate"
          />
          <WebViewVersionWarning
            :is-open="showWebViewVersionWarning"
            :current-version="detectedWebViewVersion"
            @acknowledge="acknowledgeWebViewVersionWarning"
          />
          <NotificationViewer
            v-if="
              !showAppUpdatedNotification &&
              !showWebViewVersionWarning &&
              route.name != 'onboarding'
            "
          />
        </AuthStateWatchers>

        <NotificationWarningBar />
      </TerminalWebAppAccessGate>
    </NetworkConfigWrapper>
  </ErrorBoundary>

  <template v-if="isLoading">
    <Teleport to="#full-page-loading">
      <BaseInnerLoading />
    </Teleport>
  </template>
</template>

<script setup lang="ts">
import splashImgSrc from "@brandassets/splash.png"
import { useAppUpdate } from "@/composables/useAppUpdate"
import { useShowWebViewVersionWarning } from "@/composables/useShowWebViewVersionWarning"
import TerminalWebAppAccessGate from "@/components/TerminalWebAppAccessGate.vue"

const {
  showAppUpdatedNotification,
  previousVersion,
  acknowledgeUpdate,
} = useAppUpdate()
const {
  showWebViewVersionWarning,
  detectedWebViewVersion,
  acknowledgeWebViewVersionWarning,
} = useShowWebViewVersionWarning()
const { isScreensaverVisible } = useScreensaver()
const { isLoading } = usePageBlockingLoading()
const route = useRoute()

// Hydrate grid mode state
useGridMode()

// Hydrate default till route state
useDefaultTillRoute()

// Setup socket init/close watchers
useSocket()
</script>
